import { KeyValueValidatorModel } from './key-value-validator.model';

export class KeyValueItemDefinitionModel {
    placeholder: string;
    validators: KeyValueValidatorModel[];

    constructor(init?: Partial<KeyValueItemDefinitionModel>) {
        Object.assign(this, init);
    }
}

export class KeyValueDefinitionModel {
    key: KeyValueItemDefinitionModel;
    value: KeyValueItemDefinitionModel;
    duplicateKeyMessage: string;
    emptyKeyMessage: string;
    addButtonTooltip: string;
    disabledAddButtonTooltip: string;
    removeButtonTooltip: string;

    constructor(init?: Partial<KeyValueDefinitionModel>) {
        Object.assign(this, init);
    }
}
